import { lightTheme as defaultTheme } from '@clds/themes';
import { createTheme } from './createTheme.js';
import { globalThemeId } from '../utils/globalThemeId.js';
export const globalTheme = createTheme(defaultTheme, globalThemeId);
//# sourceMappingURL=globalTheme.js.map